import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FetchUserFailure } from 'app/projects/user/src/lib/actions/fetch-entity-failure.action';
import { FetchUserSuccess } from 'app/projects/user/src/lib/actions/fetch-entity-success.action';
import { FetchUser } from 'app/projects/user/src/lib/actions/fetch-entity.action';

@Injectable()
export class TeamMemberResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const userId = route.params['userId'];

        this._store.dispatch(new FetchUser(userId));

        return this._actionHelper.race(FetchUserSuccess, FetchUserFailure);
    }
}
